
import type { PropType } from 'vue'

import type {
    DispatcherWorkplaceCourier,
    DispatcherWorkplaceItem,
    DispatcherWorkplaceProblem,
    DispatcherWorkplaceDataEntity,
} from '@/modules/DispatcherWorkplaceModule/types'

import { defineComponent, reactive } from 'vue'

import DwLoader from '@/modules/DispatcherWorkplaceModule/ui/DwLoader/index.vue'
import DW_CONSTANTS from '@/modules/DispatcherWorkplaceModule/constants'

import DwSidebarTabs from './Tabs.vue'
import DwSidebarCouriers from './Couriers.vue'
import DwSidebarOrders from './Orders.vue'
import DwSidebarProblems from './Problems.vue'

export default defineComponent({
    components: {
        'dw-loader': DwLoader,
        'dw-sidebar-tabs': DwSidebarTabs,
        'dw-sidebar-couriers': DwSidebarCouriers,
        'dw-sidebar-orders': DwSidebarOrders,
        'dw-sidebar-problems': DwSidebarProblems
    },
    props: {
        tabs: {
            type: Array as PropType<Array<{ id: string; name: string }>>,
            default: () => []
        },
        activeTab: {
            type: [String, null] as PropType<string | null>,
            default: null
        },
        couriers: {
            type: Array as PropType<Array<DispatcherWorkplaceCourier>>,
            default: () => []
        },
        showedRoutesCouriersIds: {
            type: Array as PropType<Array<number>>,
            default: () => []
        },
        items: {
            type: Array as PropType<Array<DispatcherWorkplaceItem>>,
            default: () => []
        },
        problems: {
            type: Array as PropType<Array<DispatcherWorkplaceProblem>>,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
        isCouriersCompletedOrdersEnabled: {
            type: Boolean,
            default: false,
        },
        isCouriersProblemsEnabled: {
            type: Boolean,
            default: false,
        },
        isCouriersDeliveriesEnabled: {
            type: Boolean,
            default: false,
        },
        isCouriersUndeliveredDeliveriesEnabled: {
            type: Boolean,
            default: false,
        },
        isCouriersTakesEnabled: {
            type: Boolean,
            default: false,
        },
        isCouriersUnassignedTakesEnabled: {
            type: Boolean,
            default: false,
        },
        isOrdersCompletedOrdersEnabled: {
            type: Boolean,
            default: false,
        },
        isOrdersDeliveriesEnabled: {
            type: Boolean,
            default: false,
        },
        isOrdersUndeliveredDeliveriesEnabled: {
            type: Boolean,
            default: false,
        },
        isOrdersTakesEnabled: {
            type: Boolean,
            default: false,
        },
        isOrdersUnassignedTakesEnabled: {
            type: Boolean,
            default: false,
        },
        isProblemsWaitListEnabled: {
            type: Boolean,
            default: false,
        },
        isProblemsDowntimeEnabled: {
            type: Boolean,
            default: false,
        },
        isProblemsDelayingEnabled: {
            type: Boolean,
            default: false,
        },
        isProblemsCompletedOrdersEnabled: {
            type: Boolean,
            default: false,
        },
        selectedUnassignedTakes: {
            type: Array as PropType<Array<number>>,
            default: () => []
        },
        selectedSidebarFeatureId: {
            type: String as PropType<string | null>,
            default: null
        }
    },
    emits: [
        'tab-change',
        'sidebar-toggled',
        'show-courier-route',
        'courier-entity-clicked',
        'order-entity-clicked',
        'problem-entity-clicked',
        'toggle-unassigned-take',
        'mass-appointment'
    ],
    setup(props, { emit }) {
        const state = reactive({
            is_opened: true,
        })

        const toggle = () => {
            state.is_opened = !state.is_opened
            emit('sidebar-toggled', state.is_opened)
        }

        const onTabChange = (tab_id: string) => {
            if (props.activeTab && props.activeTab === tab_id) return
            emit('tab-change', tab_id)
        }

        const onShowCourierRoute = (courier: DispatcherWorkplaceCourier) => {
            emit('show-courier-route', courier)
        }

        const onCourierEntityClicked = (dataEntity: DispatcherWorkplaceDataEntity) => {
            emit('courier-entity-clicked', dataEntity)
        }

        const onOrderEntityClicked = (dataEntity: DispatcherWorkplaceDataEntity) => {
            emit('order-entity-clicked', dataEntity)
        }

        const onProblemEntityClicked = (dataEntity: DispatcherWorkplaceDataEntity) => {
            emit('problem-entity-clicked', dataEntity)
        }

        const toggleUnassignedTake = (take_id: number) => {
            emit('toggle-unassigned-take', take_id)
        }

        const onMassAppointment = () => {
            emit('mass-appointment')
        }

        return {
            state,
            toggle,
            DW_CONSTANTS,
            onTabChange,
            onShowCourierRoute,
            onCourierEntityClicked,
            onOrderEntityClicked,
            onProblemEntityClicked,
            toggleUnassignedTake,
            onMassAppointment
        }
    }
})
